export enum ParticleTestEnum {
    FLOW_RATE_AF = 1,
    SIZE_SETTING_AF = 2,
    COUNTING_EFFICIENCY_AF = 3,
    PEAK_NOISE_AF = 4,
    SLAMPING_TIME_AF = 5,
    FALSE_COUNT_AF = 6,
    SIZE_RESOLUTION_AF = 7,
    
    FLOW_RATE_AL = 8,
    SIZE_SETTING_AL = 9,
    COUNTING_EFFICIENCY_AL = 10,
    PEAK_NOISE_AL = 11,
    SLAMPING_TIME_AL = 12,
    FALSE_COUNT_AL = 13,
    SIZE_RESOLUTION_AL = 14
}

export enum ParticleTestTypeEnum {
   AS_FOUND = 1,
   AS_LEFT = 2
}